<div (click)="toggleExpanded()" class="toggle-container">
    <div class="display--flex justify-content--space-between">
        <h3 class="display--inline-block margin--none">
        <targeting-label [label]="targetingLabel()"></targeting-label>
        </h3>

        <button class="toggle-button">
        <span class="chevron large text--info" [ngClass]="{bottom: expanded()}">
        </span>
        </button>
    </div>
    <div class="width--100 targeting-name-wrapper">
        @for(targetingName of targetingNames(); track $index;) {
            <p class="text--thin margin--none">
            {{targetingNamesData()[targetingName]}}
            </p>
        }
    </div>
    </div>
    <div class="display--flex width--100 expandable-content-wrapper">
        @if(expanded()) {
            <div
                class="margin-top--3x width--100 expandable-content"
                [@verticalExpansion]="expanded()"
                (@verticalExpansion.done)="onAnimDone()"
            >
            <ng-content></ng-content>

            </div>
        }
</div>